import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import {
  FEE_MARKETPLACE_VARIABLE,
  FEE_TXTPAY_COMPANY,
  FEE_TXTPAY_JAVELIN,
  FEE_BUSINESS_CARD,
} from './helpers';

const FeeStructureInput = ({
  setFees,
  fees,
  transactionAmount,
  transaction,
  shouldAutoCalc,
  isStatic,
  feeStructure,
}) => {
  const isDisabled = shouldAutoCalc || isStatic;
  const [feeValue, setFeeValue] = useState(0);
  // const [variableFee, setVariableFee] = useState(0);

  useEffect(() => {
    if (
      feeStructure.layout === FEE_TXTPAY_COMPANY &&
      transaction.shouldChargeTxtpayFees
    ) {
      setFees({ [feeStructure.key]: transaction.txtPayCompanyFee });
    }

    if (
      feeStructure.layout === FEE_BUSINESS_CARD &&
      transaction.isBusinessCard
    ) {
      setFees({
        [feeStructure.key]: Math.round(
          (transactionAmount - feeStructure.attributes.fixed) /
            (1 + feeStructure.attributes.percentage / 100)
        ),
      });
    }
    if (
      feeStructure.layout === FEE_TXTPAY_JAVELIN &&
      transaction.shouldChargeTxtpayFees
    ) {
      setFees({ [feeStructure.key]: transaction.txtPayJavelinFee });
    }

    if (shouldAutoCalc) {
      setFees({
        [feeStructure.key]: Math.round(
          (transactionAmount * feeStructure.attributes.percentage) / 100 +
            feeStructure.attributes.fixed
        ),
      });
    }
  }, [feeStructure, setFees, shouldAutoCalc, transaction, transactionAmount]);

  useEffect(() => {
    let FEE_VALUE = 0;
    if (feeStructure.layout === FEE_MARKETPLACE_VARIABLE) {
      FEE_VALUE = Math.round(
        (transactionAmount * feeStructure.attributes.percentage) / 100 +
          feeStructure.attributes.fixed
      );
    }

    if (
      isDisabled ||
      (feeStructure.layout === FEE_BUSINESS_CARD && transaction.isBusinessCard)
    ) {
      FEE_VALUE = fees[feeStructure.key] || 0;
    }

    setFeeValue(FEE_VALUE / 100);
  }, [
    transactionAmount,
    feeStructure,
    fees,
    isDisabled,
    transaction.isBusinessCard,
  ]);

  const _setVariableFee = (e) => {
    if (feeStructure.layout !== FEE_MARKETPLACE_VARIABLE) {
      return;
    }

    if (isNaN(e.target.value)) {
      return;
    }

    // setVariableFee(Math.round(e.target.value * 100));
  };

  return (
    <label
      key={feeStructure.key}
      htmlFor={feeStructure.key}
      className="flex flex-col lg:items-baseline mb-0 lg:flex-row"
    >
      <span className="text-xs text-javelin-gray-light w-40">
        {feeStructure.attributes.description}
      </span>
      <input
        id={feeStructure.key}
        disabled={isDisabled}
        value={feeValue}
        onInput={_setVariableFee}
        type="text"
        placeholder={feeStructure.attributes.description}
        className="input input-full-border flex-1"
      />
    </label>
  );
};

FeeStructureInput.propTypes = {
  feeStructure: PropTypes.shape({}),
};

export default FeeStructureInput;
